"use strict";
/* eslint-disable import/prefer-default-export, camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCourse = void 0;
exports.mockCourse = {
    course: {
        uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
        displayName: '.NET Advanced',
        description: 'Learn how to secure .NET web applications and practice recognizing different attacks.',
        tagline: 'Practice and learn how to secure .NET web applications.',
        iconUrl: 'https://content.codebashing.com/courses-assets/d9bde26f-e2a4-4057-ba2c-e72fafa1ecac.svg',
        name: 'dotnet_advanced_lessons',
        publishedAt: '2020-05-07T12:12:02.000Z',
        activeOnLean: false,
        isPrimary: false,
        assignedToMe: true,
        dueDate: null,
        score: 0,
        completionPercentage: 0,
        progress: null,
        hasCertificate: true,
        isSystem: true,
        numberOfLessons: 10,
        totalDuration: 50,
        quizStatus: null,
        nextLessonUrl: '/courses/dotnet_advanced_lessons/lessons/second_order_sql_injection',
    },
    lessons: [
        {
            uuid: '6167f220c27d3d842e95299d',
            displayName: 'Second Order SQL Injection',
            description: 'Second-Order SQL Injection happens when a malicious user saves the malicious payload in the database of a server-side application, and then this saved payload is used by another server-side application in its requests to the database. A successful Second-Order SQL injection attack exposes the data of the underlying database directly to the attacker. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/second_order_sql_injection.png',
            name: 'second_order_sql_injection',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:39.000Z',
            isCompleted: false,
            progress: null,
            cwe: null,
            systemCourseDisplayName: 'Java',
            tags: [
                {
                    uuid: '60f81f4db3e126e8dbee043e',
                    name: 'java',
                    displayName: 'Java',
                },
                {
                    uuid: '60f81f4db3e126e8dbee043e',
                    name: 'java',
                    displayName: 'Longg longgg tag',
                },
                {
                    uuid: '60f81f4db3e126e8dbee043e',
                    name: 'java',
                    displayName: 'Xss',
                },
                {
                    uuid: '60f81f4db3e126e8dbee043e',
                    name: 'java',
                    displayName: 'Xss1',
                },
                {
                    uuid: '60f81f4db3e126e8dbee043e',
                    name: 'java',
                    displayName: 'Xss2',
                },
            ],
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            url: '/courses/dotnet_advanced_lessons/lessons/second_order_sql_injection',
        },
        {
            uuid: '6167f2212479f131a8d55783',
            displayName: 'SQL Injection',
            description: 'SQL Injection is a type of application security vulnerability whereby a malicious user is able to manipulate the SQL statements that the application sends to the backend database server for execution. A successful SQL injection attack exposes the data of the underlying database directly to the attacker. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            name: 'sql_injection',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:39.000Z',
            isCompleted: false,
            progress: null,
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/sql_injection',
        },
        {
            uuid: '6167f21f8df88744cd76a5aa',
            displayName: 'Command Injection',
            description: 'A Command Injection vulnerability, when exploited by a malicious user, results in the execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user-supplied data (forms, cookies, HTTP headers, etc) to a system command. The malicious system command is run server side with the same privileges as the application. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            name: 'command_injection',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:39.000Z',
            isCompleted: false,
            progress: null,
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/command_injection',
        },
        {
            uuid: '6167f221c27d3d75049529a0',
            displayName: 'Session Fixation',
            description: 'Session Fixation is a type of application vulnerability where an application does not correctly renew session tokens when changing from a pre-login to post-login state. The same pre-login session token should not be used post-login, otherwise, an attacker has the potential to steal authenticated sessions of legitimate users. When a session of one user is stolen by another, it is known as a hijacked session". Play and Learn..."',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_fixation.png',
            name: 'session_fixation',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:39.000Z',
            isCompleted: false,
            progress: null,
            cwe: 'CWE-384',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/session_fixation',
        },
        {
            uuid: '6167f21fc27d3d654b95299a',
            displayName: 'Cross Site Request Forgery',
            description: 'Cross-Site Request Forgery (CSRF) is an application security vulnerability that permits an attacker to force another logged-in user of the application to perform actions within that application without realizing. The classic example is Bob and Alice both being logged-in users of an online banking application, and Bob tricks Alice into making a funds transfer to Bob',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/cross_site_request_forgery.png',
            name: 'cross_site_request_forgery',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:39.000Z',
            isCompleted: false,
            progress: null,
            cwe: 'CWE-352',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/cross_site_request_forgery',
        },
        {
            uuid: '6167f2202479f181f5d55780',
            displayName: 'Server Side Request Forgery ',
            description: 's authorization and authentication to perform attacks on the other servers inside the protected network. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses-assets/cross_site_request_forgery_post.png',
            name: 'server_side_request_forgery',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:40.000Z',
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A10: Server-Side Request Forgery ',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/server_side_request_forgery',
        },
        {
            uuid: '6167f222c27d3df76c9529a3',
            displayName: 'Use Of Insufficiently Random Values',
            description: 'In this interactive tutorial, we will demonstrate how Insufficiently Random Values used in session token generation can compromise the security of a web application, and how to write code more securely to protect against this type of attacks.\r\n\r\nNote that the problem with generating weak random values is not specific to web session generation and as such, its security implications must be considered when designing any software component that may require a random number generator.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/use_of_insufficiently_random_values.png',
            name: 'use_of_insufficiently_random_values',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:39.000Z',
            isCompleted: false,
            progress: null,
            cwe: 'CWE-330',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/use_of_insufficiently_random_values',
        },
        {
            uuid: '6167f2218df887102076a5b0',
            displayName: 'Stored (Persistent) XSS ',
            description: 'Persistent Cross-Site Scripting (XSS) is an application vulnerability whereby a malicious user tricks a web application into storing attacker-supplied script code which is then later served to the unsuspecting user of the application. The attacker-supplied script code runs on the client-side system of another end user of the application. This type of vulnerability is widespread and affects web applications that utilize (unvalidated) user-supplied input to generate (unencoded) application output, that is served to users. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
            name: 'stored_xss',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:39.000Z',
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/stored_xss',
        },
        {
            uuid: '6167f2208df887508d76a5ad',
            displayName: 'Reflected XSS',
            description: 'desc',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/reflected_xss.png',
            name: 'reflected_xss',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:40.000Z',
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/reflected_xss',
        },
        {
            uuid: '6167f2202479f1443ad5577d',
            displayName: 'Path Traversal',
            description: 'Directory (Path) Traversal is an application vulnerability that allows an attacker to access directories and files that are stored outside the web root folder. This type of vulnerability is found in applications that make insecure references to files based on the user-supplied input. A classic example is manipulating file location input variables with "dot-dot-slash (../)" sequences and its variations, to access arbitrary files and directories of the server\'s file system, such as source code or password files, or other sensitive files. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/directory_path_traversal.png',
            name: 'path_traversal',
            activeOnLean: false,
            createdAt: '2023-03-21T08:19:40.000Z',
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: false,
            dueDate: null,
            systemCourseDisplayName: '.NET Advanced',
            url: '/courses/dotnet_advanced_lessons/lessons/path_traversal',
        },
    ],
    units: [],
    success: true,
    quiz: {
        status: 'not_completed',
        quizId: 1,
        numberOfQuestions: 2,
        attemptsAllowed: 3,
        incorrectQuestionsAllowed: 2,
    },
};
